import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }

    // Only trigger role-based redirect on root path
    if (state.url === '/') {
      if (this.authService.isAdmin()) {
        this.router.navigate(['/features/announcement']);
      } else {
        this.router.navigate(['/transactions/all-transaction']);
      }
      return false;
    }

    return true;
  }
}
